import { Mapper } from "../../../../base/utils/mapper";
import { EPSModel } from "../../../../domain/models/configuration/eps.model";
import { EPSEntity } from "../entities/eps.entity";



export class EPSImplementationRepositoryMapper extends Mapper<EPSEntity, EPSModel> {
    mapFrom(param: EPSEntity): EPSModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: EPSModel): EPSEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}